import { CSSProperties } from "react";

export const formPanelSectionStyles: {
    panel: CSSProperties;
    header: CSSProperties;
} = {
    panel: {
        border: `1px solid var(--color-disabled-light)`,
        borderRadius: "var(--space-02)",
        padding: "var(--space-card-padding)",
        background: "var(--color-background)",
    },
    header: {
        display: "flex",
        alignItems: "center",
        gap: "var(--space-tight-padding)",
        borderBottom: `1px solid var(--color-divider-light)`,
        paddingBottom: "var(--space-tight-padding)",
        marginBottom: "var(--space-form-field-gap)",
        color: "var(--color-text-dark)",
        fontWeight: 700,
    },
};